import React from 'react'
import { useTranslation } from 'react-i18next'
import { Gem } from 'lucide-react'

const DoubleBetsFeed = ({ bets = [] }) => {
  const { t } = useTranslation()

  const colorColumns = [
    {
      key: 'red',
      cardClass: 'border-red-400/35 bg-red-500/12'
    },
    {
      key: 'black',
      cardClass: 'border-white/20 bg-slate-900/45'
    },
    {
      key: 'green',
      cardClass: 'border-emerald-400/35 bg-emerald-500/12'
    }
  ]

  const safeBets = Array.isArray(bets) ? bets : []

  return (
    <div>
      <div className="grid gap-3 lg:grid-cols-3">
        {colorColumns.map((column) => {
          const columnBets = safeBets.filter((bet) => String(bet.color || '') === column.key)

          return (
            <div key={column.key} className="min-h-0">
              <div className="space-y-2 max-h-[360px] overflow-y-auto pr-1">
                {columnBets.map((bet, index) => (
                  <div
                    key={`${bet.chat_id || 'anon'}-${column.key}-${index}`}
                    className={`rounded-xl border p-3 ${column.cardClass}`}
                  >
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-2 min-w-0">
                        <img
                          src={bet.ava}
                          alt={bet.name}
                          className="w-9 h-9 rounded-full object-cover border border-white/20"
                        />
                        <div className="min-w-0">
                          <p className="text-sm text-white font-semibold truncate">{bet.name || t('double.common.player', 'Игрок')}</p>
                        </div>
                      </div>

                      <span className="inline-flex items-center gap-1 text-sm font-semibold text-accent-primary">
                        {Number(bet.sum || 0).toLocaleString()} <Gem className="w-4 h-4" />
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default DoubleBetsFeed
